export default "__VITE_ASSET__a9f7b0f4__"